import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Layout from "./components/common/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import Branch from "./pages/Branch";
import Employee from "./pages/Employee";
import Users from "./pages/Users";
import Customer from "./pages/Customer";
import DailyCall from "./pages/DailyCall";
import Audit from "./pages/AuditLog";

import ImportDailyCall from "./pages/imports/ImportDailyCall";
import CustomerImport from "./pages/imports/CustomerImport";
import DailyCallReport from "./pages/reports/DailyCallReport";
import DailyService from "./pages/DailyService";
import ServiceReport from "./pages/reports/ServiceReport";
import Dashboard from "./pages/dashboard/Dashboard";
import ServiceDashboard from "./pages/dashboard/ServiceDashboard";
import VoucherPrint from "./pages/voucher/VoucherPrint";
import VoucherEntry from "./pages/voucher/VoucherEntry";
import VoucherDashboard from "./pages/dashboard/VoucherDashboard";
import Home from "./pages/Home/Home";
function App() {
    return (
        <Router>
            <Routes>

                {/* 🔐 LOGIN */}
                <Route path="/" element={<Login />} />

                {/* 🔒 PROTECTED APP */}
                <Route
                    path="/app"
                    element={
                        <ProtectedRoute>
                            <Layout />
                        </ProtectedRoute>
                    }
                >

                    {/* Default */}
                    <Route index element={<Navigate to="home" />} />
                    <Route path="home" element={<Home />} />

                    {/* ===== Masters ===== */}
                    <Route path="branch" element={<Branch />} />
                    <Route path="employee" element={<Employee />} />
                    <Route path="users" element={<Users />} />
                    <Route path="customers" element={<Customer />} />

                    {/* ===== Transactions ===== */}
                    {/* ===== Transactions ===== */}
                    <Route path="daily-call" element={<DailyCall />} />
                    <Route path="daily-service" element={<DailyService />} />
                    <Route path="voucher-entry" element={<VoucherEntry />} />
                    <Route path="/app/voucher-print/:id" element={<VoucherPrint />} />
                    <Route path="/app/voucher-edit/:id" element={<VoucherEntry />} />

                    {/* ===== System ===== */}
                    <Route path="audit" element={<Audit />} />
                    <Route path="import-daily-call" element={<ImportDailyCall />} />
                    <Route path="customer-import" element={<CustomerImport />} />

                    {/* ===== Reports ===== */}
                    <Route path="daily-call-report" element={<DailyCallReport />} />
                    <Route path="service-report" element={<ServiceReport />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="service-dashboard" element={<ServiceDashboard />} />
                    <Route path="/app/voucher-dashboard" element={<VoucherDashboard />} />

                </Route>
                {/* ❌ fallback */}
                <Route path="*" element={<Navigate to="/" />} />

            </Routes>
        </Router>
    );
}

export default App;